import {Service} from "crqlar-react-common/dist/models/service/service.model"
import {ServiceStatus} from "crqlar-react-common/dist/models/service/serviceStatus.model"

type CategoryNumberMap = Record<string, number | undefined>

const cleanCategoryNumberMap = (values?: CategoryNumberMap): CategoryNumberMap | undefined => {
    if (!values) return undefined

    const entries = Object.entries(values).filter(([categoryId, value]) =>
        !!categoryId.trim() && typeof value === 'number' && Number.isFinite(value)
    )

    return entries.length ? Object.fromEntries(entries) : undefined
}

export const isServiceValid = (service: Service) => !!service.name?.trim()

export const prepareServiceForSave = (service: Service): Service => ({
    ...service,
    name: service.name?.trim(),
    status: service.status ?? ServiceStatus.ACTIVE,
    durationMinutes: service.noShowService ? undefined : service.durationMinutes,
    preparationTimeMinutes: cleanCategoryNumberMap(service.preparationTimeMinutes),
    resourceCategoryDurationMinutes: cleanCategoryNumberMap(service.resourceCategoryDurationMinutes),
    assignedResourcesRequirementPerCategory: cleanCategoryNumberMap(service.assignedResourcesRequirementPerCategory),
})
